var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.adjustStoreModal
        ? _c(
            "EmptyCardModal",
            {
              ref: "emptyModal",
              attrs: {
                onModalClose: (reset) => (_vm.adjustStoreModal = null),
                onModalAccept: () =>
                  _vm.adjustStoreAction(_vm.adjustStoreModal.drugId, true),
                modalData: _vm.adjustStoreModal,
              },
            },
            [
              _vm._t("default", function () {
                return [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _vm.adjustStoreModal.invoices.income.qty
                          ? [
                              _c("p", [
                                _vm._v("Поступление "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.sortedStores[3]?.short_title)
                                  ),
                                ]),
                                _vm._v(" количество\n              "),
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.adjustStoreModal.invoices.income.qty
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("hr"),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.adjustStoreModal.invoices.writeOff.length
                          ? [
                              _vm._l(
                                _vm.adjustStoreModal.invoices.writeOff,
                                function (writeOff) {
                                  return _c("p", [
                                    _vm._v("Списание\n              "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.sortedStores[writeOff.store_out]
                                            ?.short_title
                                        )
                                      ),
                                    ]),
                                    _vm._v(" количество\n              "),
                                    _c("strong", [
                                      _vm._v(_vm._s(writeOff.qty)),
                                    ]),
                                  ])
                                }
                              ),
                              _vm._v(" "),
                              _c("hr"),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          _vm.adjustStoreModal.invoices.transit,
                          function (transit) {
                            return _c("p", [
                              _vm._v("Транзит\n            "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.sortedStores[transit.store_out]
                                      ?.short_title
                                  )
                                ),
                              ]),
                              _vm._v(" =>\n            "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.sortedStores[transit.store_in]
                                      ?.short_title
                                  )
                                ),
                              ]),
                              _vm._v(" количество\n            "),
                              _c("strong", [_vm._v(_vm._s(transit.qty))]),
                            ])
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6 border-left" },
                      [
                        _vm._l(
                          _vm.adjustStoreData[_vm.adjustStoreModal.drugId]
                            .newStoreQty,
                          function (qty, storeId) {
                            return +_vm.storeData.actualStoreData[
                              _vm.adjustStoreModal.drugId
                            ][storeId] !== +qty
                              ? _c("p", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.sortedStores[storeId]?.short_title
                                      ) +
                                      "\n            "
                                  ),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.storeData.actualStoreData[
                                          _vm.adjustStoreModal.drugId
                                        ][storeId]
                                      )
                                    ),
                                  ]),
                                  _vm._v("\n            => "),
                                  _c("strong", [_vm._v(_vm._s(qty))]),
                                ])
                              : _vm._e()
                          }
                        ),
                        _vm._v(" "),
                        _vm._l(
                          _vm.adjustStoreData[_vm.adjustStoreModal.drugId]
                            .newStore,
                          function (s) {
                            return +s.storeId &&
                              +s.newQty !==
                                +_vm.storeData.actualStoreData[
                                  _vm.adjustStoreModal.drugId
                                ][s.storeId]
                              ? _c("p", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.sortedStores[s.storeId]?.short_title
                                      ) +
                                      "\n            "
                                  ),
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.storeData.actualStoreData[
                                          _vm.adjustStoreModal.drugId
                                        ][s.storeId]
                                      )
                                    ),
                                  ]),
                                  _vm._v("\n            => "),
                                  _c("strong", [_vm._v(_vm._s(s.newQty))]),
                                ])
                              : _vm._e()
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "table table-sm table-hover" }, [
        _c("thead", [
          _c(
            "tr",
            [
              _vm.showDrugTitle
                ? [
                    _c("th", [_vm._v("Морион")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("Наименование")]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("th", [_vm._v("Склад")]),
              _vm._v(" "),
              _c("th", [_vm._v("Наличие")]),
              _vm._v(" "),
              _c("th", [_vm._v("Фактич")]),
              _vm._v(" "),
              _c("th"),
              _vm._v(" "),
              _c("th", [_vm._v("Р. бронь")]),
              _vm._v(" "),
              _c("th", [_vm._v("Не р. бронь")]),
              _vm._v(" "),
              _c("th", [_vm._v("В дороге")]),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.selectedDrugs, function (drug) {
              return _vm.storeData && _vm.storeData.inStores[drug.id]
                ? [
                    _vm.showDrugTitle
                      ? [
                          _c("tr", { staticClass: "main_tr" }, [
                            _c(
                              "td",
                              {
                                attrs: {
                                  rowspan: _vm.getRecordsCount(drug.id),
                                },
                              },
                              [_vm._v(_vm._s(drug.id))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                attrs: {
                                  rowspan: _vm.getRecordsCount(drug.id),
                                },
                              },
                              [
                                _vm.allowToGetMoves
                                  ? [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.getExternalLink(drug),
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-fa-external-link",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "pointer",
                                          on: {
                                            click: function ($event) {
                                              return _vm.mixinGoToRouter(
                                                "NomenclatureStatistics",
                                                { drugId: drug.id }
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(drug.title))]
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(drug.title) +
                                          "\n            "
                                      ),
                                    ],
                                _vm._v(" "),
                                drug.pack_set && drug.pack_set != 1
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticClass: "mb-0 badge badge-info",
                                        },
                                        [
                                          _vm._v(
                                            "комплект x " +
                                              _vm._s(drug.pack_set)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "text-muted" }, [
                                        _vm._v(
                                          "Учет ведется в заводских упаковках!"
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$can("stores/status/autoAdjust")
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "mt-2" },
                                        _vm._l(
                                          _vm.storeData.extraInvoices,
                                          function (inv) {
                                            return _c(
                                              "p",
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      inv.extra_type
                                                        ? "Коррекция"
                                                        : "Списание"
                                                    ) +
                                                    " "
                                                ),
                                                _c("strong", [
                                                  _vm._v(_vm._s(inv.total)),
                                                ]),
                                                _vm._v(" "),
                                                inv.extra_type
                                                  ? [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "btn btn-xs btn-outline-info",
                                                          attrs: {
                                                            type: "button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.showExtraInvoices(
                                                                inv,
                                                                drug.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "icon-fa icon-fa-eye",
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  : [
                                                      _c("LoadingButton", {
                                                        attrs: {
                                                          title:
                                                            '<i class="icon-fa icon-fa-eye"/>',
                                                          loading:
                                                            _vm.writeOffLoading[
                                                              drug.id
                                                            ],
                                                          type: "button",
                                                          color:
                                                            _vm.$constants
                                                              .PRIMARY_COLOR,
                                                          onClick: () =>
                                                            _vm.showExtraInvoices(
                                                              inv,
                                                              drug.id
                                                            ),
                                                          className:
                                                            "btn btn-xs btn-outline-info",
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.getStores(), function (store) {
                      return (_vm.storeData.inStores[drug.id] &&
                        _vm.storeData.inStores[drug.id][store.id]) ||
                        (_vm.storeData.requests[drug.id] &&
                          _vm.storeData.requests[drug.id][store.id]) ||
                        (_vm.storeData.transitDetails[drug.id] &&
                          _vm.storeData.transitDetails[drug.id][store.id])
                        ? _c("tr", [
                            _c(
                              "td",
                              {
                                class: { grey_field: store.id === 3 },
                                attrs: { width: "250px" },
                              },
                              [
                                _vm.allowToGetMoves
                                  ? [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.getExternalLink(
                                              drug,
                                              store.id
                                            ),
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "icon-fa icon-fa-external-link",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.hideStoreLink
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "pointer",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.mixinGoToRouter(
                                                      "NomenclatureStatistics",
                                                      {
                                                        drugId: drug.id,
                                                        storeId: store.id,
                                                      }
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(store.title) +
                                                    " (" +
                                                    _vm._s(store.id) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                          ]
                                        : [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(store.title) +
                                                  " (" +
                                                  _vm._s(store.id) +
                                                  ")"
                                              ),
                                            ]),
                                          ],
                                    ]
                                  : [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(store.title) +
                                          "\n          "
                                      ),
                                    ],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "grey_field w_store_d" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      _vm.storeData.inStores[drug.id][
                                        store.id
                                      ] * 10
                                    ) / 10 || 0
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "w_store_d" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    (_vm.storeData.actualStoreData[drug.id] &&
                                      _vm.storeData.actualStoreData[drug.id][
                                        store.id
                                      ]) ||
                                      0
                                  ) +
                                  "\n        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm.adjustStore && _vm.adjustStore[drug.id]
                                  ? [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.adjustStoreData[drug.id]
                                                .newStoreQty[store.id],
                                            expression:
                                              "adjustStoreData[drug.id].newStoreQty[store.id]",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "number",
                                          placeholder: "Новое кол.",
                                        },
                                        domProps: {
                                          value:
                                            _vm.adjustStoreData[drug.id]
                                              .newStoreQty[store.id],
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.adjustStoreData[drug.id]
                                                .newStoreQty,
                                              store.id,
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "w_store_d" },
                              [
                                _vm.storeData.requests &&
                                _vm.storeData.requests[drug.id] &&
                                _vm.storeData.requests[drug.id][store.id] &&
                                _vm.storeData.requests[drug.id][store.id][
                                  _vm.reserveTypes.appointedReserve
                                ] &&
                                _vm.storeData.requests[drug.id][store.id][
                                  _vm.reserveTypes.appointedReserve
                                ].qty
                                  ? [
                                      _vm.showStoreDataTooltip[drug.id]
                                        ? [
                                            _c(
                                              "v-popover",
                                              {
                                                attrs: {
                                                  popoverClass: "1111 p-3",
                                                  popoverInnerClass:
                                                    "upload_file_component_popover",
                                                  update: (open) => {
                                                    _vm.console.log("111", open)
                                                  },
                                                  "close-directive": () => {
                                                    _vm.console.log("1112")
                                                  },
                                                  trigger: "hover",
                                                  "auto-hide": true,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "badge badge-dark pointer fs-12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.storeData
                                                            .requests[drug.id][
                                                            store.id
                                                          ][
                                                            _vm.reserveTypes
                                                              .appointedReserve
                                                          ].qty
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "template",
                                                  { slot: "popover" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pre_image",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    Заявки:\n                    "
                                                        ),
                                                        _vm._l(
                                                          _vm.storeData
                                                            .requests[drug.id][
                                                            store.id
                                                          ][
                                                            _vm.reserveTypes
                                                              .appointedReserve
                                                          ].orders,
                                                          function (o) {
                                                            return _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(o)
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href: "#",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.openInNewPage(
                                                                      "searchOrder",
                                                                      {
                                                                        ordersId:
                                                                          _vm
                                                                            .storeData
                                                                            .requests[
                                                                            drug
                                                                              .id
                                                                          ][
                                                                            store
                                                                              .id
                                                                          ][
                                                                            _vm
                                                                              .reserveTypes
                                                                              .appointedReserve
                                                                          ]
                                                                            .orders,
                                                                      }
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        Показать заявки\n                      "
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "badge badge-dark pointer fs-12",
                                                on: {
                                                  mouseover: function ($event) {
                                                    _vm.showStoreDataTooltip[
                                                      drug.id
                                                    ] = true
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.storeData.requests[
                                                        drug.id
                                                      ][store.id][
                                                        _vm.reserveTypes
                                                          .appointedReserve
                                                      ].qty
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            ),
                                          ],
                                    ]
                                  : [_vm._v("0")],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "w_store_d" },
                              [
                                _vm.storeData.requests &&
                                _vm.storeData.requests[drug.id] &&
                                _vm.storeData.requests[drug.id][store.id] &&
                                _vm.storeData.requests[drug.id][store.id][
                                  _vm.reserveTypes.noAppointedReserve
                                ] &&
                                _vm.storeData.requests[drug.id][store.id][
                                  _vm.reserveTypes.noAppointedReserve
                                ].qty
                                  ? [
                                      _vm.showStoreDataTooltip[drug.id]
                                        ? [
                                            _c(
                                              "v-popover",
                                              {
                                                attrs: {
                                                  popoverClass: "1111 p-3",
                                                  popoverInnerClass:
                                                    "upload_file_component_popover",
                                                  trigger: "hover",
                                                  "auto-hide": true,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "badge badge-dark pointer fs-12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.storeData
                                                            .requests[drug.id][
                                                            store.id
                                                          ][
                                                            _vm.reserveTypes
                                                              .noAppointedReserve
                                                          ].qty
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "template",
                                                  { slot: "popover" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pre_image",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    Заявки:\n                    "
                                                        ),
                                                        _vm._l(
                                                          _vm.storeData
                                                            .requests[drug.id][
                                                            store.id
                                                          ][
                                                            _vm.reserveTypes
                                                              .noAppointedReserve
                                                          ].orders,
                                                          function (o) {
                                                            return _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(o)
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _c("p", [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href: "#",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.openInNewPage(
                                                                      "searchOrder",
                                                                      {
                                                                        ordersId:
                                                                          _vm
                                                                            .storeData
                                                                            .requests[
                                                                            drug
                                                                              .id
                                                                          ][
                                                                            store
                                                                              .id
                                                                          ][
                                                                            _vm
                                                                              .reserveTypes
                                                                              .noAppointedReserve
                                                                          ]
                                                                            .orders,
                                                                      }
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        Показать заявки\n                      "
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "badge badge-dark pointer fs-12",
                                                on: {
                                                  mouseover: function ($event) {
                                                    _vm.showStoreDataTooltip[
                                                      drug.id
                                                    ] = true
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.storeData.requests[
                                                        drug.id
                                                      ][store.id][
                                                        _vm.reserveTypes
                                                          .noAppointedReserve
                                                      ].qty
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            ),
                                          ],
                                    ]
                                  : [_vm._v("0")],
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "w_store_d" },
                              [
                                _vm.storeData.transitDetails[drug.id] &&
                                _vm.storeData.transitDetails[drug.id][store.id]
                                  ? [
                                      _vm.showStoreDataTooltip[drug.id]
                                        ? [
                                            _c(
                                              "v-popover",
                                              {
                                                attrs: {
                                                  popoverClass: "1111 p-3",
                                                  popoverInnerClass:
                                                    "upload_file_component_popover",
                                                  trigger: "hover",
                                                  "auto-hide": true,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "badge badge-dark pointer fs-12",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.getTransitQty(
                                                            _vm.storeData
                                                              .transitDetails[
                                                              drug.id
                                                            ][store.id]
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "template",
                                                  { slot: "popover" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pre_image",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    Накладные:\n                    "
                                                        ),
                                                        _vm.storeData
                                                          .transitDetails[
                                                          drug.id
                                                        ][store.id].details_in
                                                          ? [
                                                              _c("p", [
                                                                _vm._v(
                                                                  "Поступление:"
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm.storeData
                                                                  .transitDetails[
                                                                  drug.id
                                                                ][store.id]
                                                                  .details_in,
                                                                function (i) {
                                                                  return _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "mb-1",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            i.invoice_id
                                                                          ) +
                                                                          " (" +
                                                                          _vm._s(
                                                                            i.qty
                                                                          ) +
                                                                          ")"
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                            ]
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _vm.storeData
                                                          .transitDetails[
                                                          drug.id
                                                        ][store.id].details_out
                                                          ? [
                                                              _c("p", [
                                                                _vm._v(
                                                                  "Отправка:"
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                _vm.storeData
                                                                  .transitDetails[
                                                                  drug.id
                                                                ][store.id]
                                                                  .details_out,
                                                                function (i) {
                                                                  return _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "mb-1",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                        " +
                                                                          _vm._s(
                                                                            i.invoice_id
                                                                          ) +
                                                                          " (" +
                                                                          _vm._s(
                                                                            i.qty
                                                                          ) +
                                                                          ")"
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                            ]
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "badge badge-dark pointer fs-12",
                                                on: {
                                                  mouseover: function ($event) {
                                                    _vm.showStoreDataTooltip[
                                                      drug.id
                                                    ] = true
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.getTransitQty(
                                                        _vm.storeData
                                                          .transitDetails[
                                                          drug.id
                                                        ][store.id]
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]
                                            ),
                                          ],
                                    ]
                                  : [_vm._v("0")],
                                _vm._v(" "),
                                _vm.storeData.transitDetails[drug.id]?.[
                                  store.id
                                ]?.in &&
                                _vm.storeData.transitDetails[drug.id]?.[
                                  store.id
                                ]?.out
                                  ? _c("div", { staticClass: "border p-1" }, [
                                      _vm._v(
                                        "\n            -" +
                                          _vm._s(
                                            _vm.storeData.transitDetails[
                                              drug.id
                                            ][store.id].out
                                          ) +
                                          "c/+" +
                                          _vm._s(
                                            _vm.storeData.transitDetails[
                                              drug.id
                                            ][store.id].in
                                          ) +
                                          "на\n          "
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ])
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm.$can("stores/status/autoAdjust")
                      ? [
                          _vm.adjustStore[drug.id]
                            ? _vm._l(
                                _vm.adjustStoreData[drug.id]?.newStore,
                                function (adjust, i) {
                                  return _c("tr", [
                                    _c("td", { attrs: { colspan: "2" } }),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: adjust.storeId,
                                              expression: "adjust.storeId",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          on: {
                                            change: function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                adjust,
                                                "storeId",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                disabled: "",
                                                value: "0",
                                              },
                                            },
                                            [_vm._v("Выберите склад")]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.$AllStores, function (s) {
                                            return adjust.allowedStores[s.id]
                                              ? _c(
                                                  "option",
                                                  { domProps: { value: s.id } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(s.title) +
                                                        "\n                  (" +
                                                        _vm._s(s.id) +
                                                        ")\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e()
                                          }),
                                        ],
                                        2
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { attrs: { colspan: "2" } }),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: adjust.newQty,
                                            expression: "adjust.newQty",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "number",
                                          placeholder: "Новое кол.",
                                        },
                                        domProps: { value: adjust.newQty },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              adjust,
                                              "newQty",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    i === 0
                                      ? _c(
                                          "td",
                                          {
                                            attrs: {
                                              colspan: "3",
                                              align: "right",
                                            },
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-outline-success",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.adjustStoreAction(
                                                      drug.id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                Обновить склады\n              "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                }
                              )
                            : [
                                !_vm.disableCorrection
                                  ? _c("tr", [
                                      _c("td", { attrs: { colspan: "12" } }, [
                                        _c("label", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.adjustStore[drug.id],
                                                expression:
                                                  "adjustStore[drug.id]",
                                              },
                                            ],
                                            attrs: { type: "checkbox" },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.adjustStore[drug.id]
                                              )
                                                ? _vm._i(
                                                    _vm.adjustStore[drug.id],
                                                    null
                                                  ) > -1
                                                : _vm.adjustStore[drug.id],
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a =
                                                      _vm.adjustStore[drug.id],
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = null,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        _vm.$set(
                                                          _vm.adjustStore,
                                                          drug.id,
                                                          $$a.concat([$$v])
                                                        )
                                                    } else {
                                                      $$i > -1 &&
                                                        _vm.$set(
                                                          _vm.adjustStore,
                                                          drug.id,
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            )
                                                        )
                                                    }
                                                  } else {
                                                    _vm.$set(
                                                      _vm.adjustStore,
                                                      drug.id,
                                                      $$c
                                                    )
                                                  }
                                                },
                                                function ($event) {
                                                  return _vm.editAdjustStore(
                                                    drug.id
                                                  )
                                                },
                                              ],
                                            },
                                          }),
                                          _vm._v(
                                            "\n                корректировать склады\n              "
                                          ),
                                        ]),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ],
                        ]
                      : _vm._e(),
                  ]
                : _vm._e()
            }),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }